import { NOTIFICATION_STATUSES, STEP_STATUS } from "./notifications.consts";

export const getNotificationStatus = (steps) => {
  for (const step of steps) {
    if (step.status === STEP_STATUS.CANCELED) {
      return NOTIFICATION_STATUSES.CANCELED;
    }

    if (step.status === STEP_STATUS.IN_PROGRESS || step.status === STEP_STATUS.NOT_STARTED) {
      return NOTIFICATION_STATUSES.IN_PROGRESS;
    }

    if (step.status === STEP_STATUS.FAILED) {
      return NOTIFICATION_STATUSES.FAILED;
    }
  }

  return NOTIFICATION_STATUSES.COMPLETED;
};
